import React, { useState, useContext, useEffect } from "react";
import PsContext from "../../../context";
import { Card, Col, Row } from "react-bootstrap";
import { APP_TYPE, COLLEGE, DB_POSTFIX } from "../../../utils";
import axios from "axios";
import { ServiceUrl } from "../../../utils/serviceUrl";

const ProgrammesOfferedPage = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    loadPage();
  }, []);

  const loadPage = () => {
    setLoader(true);
    let url = "";
    if (APP_TYPE == "SAAS") url = "&sadb=" + DB_POSTFIX;
    axios
      .get(
        ServiceUrl.ADMISSION.CUSTOM_PAGE +
          "?slug=admission-programmes-offered" +
          url,
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
        }
        setLoader(false);
      });
  };

  return (
    <>
      {dataList && dataList.id && (
        <section>
          <div className="container py-5">
            <Row className="mb-3">
              <Col md={12}>
                <h3 className="title_with_halfLine">Programmes Offered</h3>
              </Col>
            </Row>

            {dataList && dataList.id && (
              <div
                className="fs-14"
                style={{ overflowX: "hidden" }}
                dangerouslySetInnerHTML={{
                  __html: dataList.content_html,
                }}
              />
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default ProgrammesOfferedPage;
